import { FC, useState, useRef } from 'react';
import { createPortal } from 'react-dom';

const Tooltip: FC<{ children: React.ReactNode; text: string }> = ({ text, children }) => {
  const [hover, setHover] = useState(false);
  const ref = useRef<HTMLSpanElement | null>(null);
  const [coords, setCoords] = useState({ top: 0, left: 0 });

  const handleEnter = () => {
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect();

      setCoords({
        top: rect.bottom + 8,
        left: rect.right - 200,
      });
    }

    setHover(true);
  };

  return (
    <>
      <span ref={ref} onMouseEnter={handleEnter} onMouseLeave={() => setHover(false)} className="inline-block">
        {children}
      </span>

      {hover &&
        createPortal(
          <div
            className="fixed z-[9999] w-[200px] bg-white p-[6px_10px] rounded-[6px] text-sm text-blackBase shadow-formFeedback border border-[#dd7373]"
            style={{
              top: coords.top,
              left: coords.left,
            }}
          >
            {text}
          </div>,
          document.body,
        )}
    </>
  );
};

export default Tooltip;
